<template>
  <router-view></router-view>
</template>

<script>
// const websocketUrl = process.env.VUE_APP_WEBSOCKET_URL;

export default {
  name: "App",
//   data() {
//     return {
//       socket: null
//     };
//   },
//   mounted() {
//     this.socket = new WebSocket(websocketUrl);
//   },
//   destroyed() {
//     this.socket && this.socket.close();
//   }
};
</script>
